import styled from 'styled-components';
import Autocomplete from '@material-ui/lab/Autocomplete';
export const $Autocomplete = styled(Autocomplete) `
  .MuiInputBase-root {
    width: 100%;
  }
`;
